
interface SimpleHeaderProps {
  user: any;
  currentLang: "ro" | "en";
  title: string;
  stats?: {
    available: number;
    used: number;
    activated: number;
  };
}

export function SimpleHeader({
  user: _user,
  currentLang,
  title,
  stats,
}: SimpleHeaderProps) {
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="/suuper_pin.svg" 
            alt="Suuper" 
            className="h-8 w-auto"
          />
          <p className="text-primary  text-2xl font-semibold">{title}</p>
        </div>
      </div>

      {/* Stats cards pentru invites */}
      {stats && (
        <div className="flex flex-row gap-3 mt-4">
          <div className="bg-white/10 rounded-xl p-3 text-center flex-1">
            <p className="text-2xl font-bold">{stats.available}</p>
            <p className="text-xs text-white/70">
              {currentLang === "ro" ? "Disponibile" : "Available"}
            </p>
          </div>
          <div className="bg-white/10 rounded-xl p-3 text-center flex-1">
            <p className="text-2xl font-bold">{stats.used}</p>
            <p className="text-xs text-white/70">
              {currentLang === "ro" ? "Folosite" : "Used"}
            </p>
          </div>
          <div className="bg-white/10 rounded-xl p-3 text-center flex-1">
            <p className="text-2xl font-bold">{stats.activated}</p>
            <p className="text-xs text-white/70">
              {currentLang === "ro" ? "Activate" : "Activated"}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
